export default {
  0: {
    size: 80,
    beforeSize: 74,
    afterSize: 0,
  },
  1: {
    size: 56,
    beforeSize: 52,
    afterSize: 0,
    iconWidth: 30,
  },
  2: {
    size: 76,
    beforeSize: 70,
    afterSize: 0,
  },
  3: {
    size: 71,
    beforeSize: 65,
    afterSize: 80,
  },
  4: {
    size: 50,
    beforeSize: 46,
    afterSize: 0,
    iconWidth: 20,
    compareCard: true,
  },
  5: {
    size: 80,
    beforeSize: 80,
    afterSize: 0,
  },
  6: {
    size: 50,
    beforeSize: 46,
    afterSize: 0,
    iconWidth: 20,
  },
};
